import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { categories: Object, photosOptional: Object }
  static targets = [ "attrsContainer", "categoryFields", "photoLabel", "photoSection", "applicableField" ]

  connect() {
    this.categorySelect = this.element.querySelector("select[name='ad[category_id]']")
    if (this.categorySelect) {
      this.categorySelect.addEventListener("change", () => this.renderFields())
      this.renderFields()
    }
  }

  renderFields() {
    const slug = this.selectedCategorySlug()

    this.categoryFieldsTargets.forEach((block) => {
      const isActive = block.dataset.categorySlug === slug
      block.classList.toggle("hidden", !isActive)
      this.setSelectsDisabled(block, !isActive)
    })

    this.updatePhotoState()

    if (!slug) return

    const activeBlock = this.categoryFieldsTargets.find((b) => b.dataset.categorySlug === slug)
    if (!activeBlock) return

    const brandInput = activeBlock.querySelector("input[name='ad[attrs][brand]']")
    const subtypeSelect = activeBlock.querySelector("select[name='ad[attrs][subtype]']")
    if (brandInput && subtypeSelect) {
      if (!subtypeSelect.dataset.brandListenerAttached) {
        subtypeSelect.addEventListener("change", () => this.updateBrandDatalist(slug, subtypeSelect.value, brandInput))
        subtypeSelect.dataset.brandListenerAttached = "true"
      }
      this.updateBrandDatalist(slug, subtypeSelect.value, brandInput)
    }

    const serviceSelect = activeBlock.querySelector("select[name='ad[attrs][service_type]']")
    if (serviceSelect) {
      if (!serviceSelect.dataset.serviceListenerAttached) {
        serviceSelect.addEventListener("change", () => {
          this.toggleServiceOther(serviceSelect)
          this.toggleApplicableFields(activeBlock)
        })
        serviceSelect.dataset.serviceListenerAttached = "true"
      }
      this.toggleServiceOther(serviceSelect)
      this.toggleApplicableFields(activeBlock)
    } else {
      this.toggleApplicableFields(activeBlock)
    }
  }

  selectedCategoryId() {
    if (!this.categorySelect) return null
    return this.categorySelect.value
  }

  updatePhotoState() {
    if (!this.hasPhotoLabelTarget && !this.hasPhotoSectionTarget) return

    const categoryId = this.selectedCategoryId()
    const optional = categoryId ? !!this.photosOptionalValue[categoryId] : false

    if (this.hasPhotoLabelTarget) {
      this.photoLabelTarget.innerHTML = optional
        ? "Фото (необязательно)"
        : 'Фото <span class="text-red-500">*</span>'
    }

    if (this.hasPhotoSectionTarget) {
      this.photoSectionTarget.dataset.formValidationOptional = optional ? "true" : "false"
    }
  }

  setSelectsDisabled(block, disabled) {
    block.querySelectorAll("[data-ad-form-target='attrSelect']").forEach((select) => {
      select.disabled = disabled
    })
  }

  selectedCategorySlug() {
    const option = this.categorySelect.selectedOptions[0]
    if (!option) return null

    const categoryId = option.value
    return this.categoriesValue[categoryId]
  }

  updateBrandDatalist(categorySlug, subtype, brandInput) {
    const datalistId = "datalist-brand"
    let datalist = document.getElementById(datalistId)

    if (!datalist) {
      datalist = document.createElement("datalist")
      datalist.id = datalistId
      brandInput.parentNode.appendChild(datalist)
      brandInput.setAttribute("list", datalistId)
    }

    const brands = this.brandsBySubtype()[subtype] || []
    datalist.innerHTML = brands.map((v) => `<option value="${this.escapeHtml(v)}">`).join("")
  }

  toggleServiceOther(serviceSelect) {
    const block = serviceSelect.closest("[data-ad-form-target='categoryFields']")
    if (!block) return

    const otherWrapper = block.querySelector("[data-ad-form-target='serviceTypeOther']")
    if (!otherWrapper) return

    otherWrapper.classList.toggle("hidden", serviceSelect.value !== "drugoe")
  }

  toggleApplicableFields(activeBlock) {
    if (!activeBlock) return

    const serviceSelect = activeBlock.querySelector("select[name='ad[attrs][service_type]']")
    const serviceType = serviceSelect ? serviceSelect.value : null

    activeBlock.querySelectorAll("[data-ad-form-target='applicableField']").forEach((wrapper) => {
      const allowed = (wrapper.dataset.applicableServiceTypes || "").split(",").filter(Boolean)
      const isApplicable = serviceType && allowed.includes(serviceType)

      wrapper.classList.toggle("hidden", !isApplicable)

      const select = wrapper.querySelector("select")
      if (select && !isApplicable) {
        select.value = ""
        select.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })
  }

  brandsBySubtype() {
    return {
      "legkovoy": [ "Lada", "Toyota", "Kia", "Hyundai", "Renault", "Nissan", "Volkswagen", "Skoda", "УАЗ", "ГАЗ", "Chevrolet", "Ford" ],
      "gruzovik": [ "КамАЗ", "МАЗ", "Урал", "ГАЗ", "ЗИЛ" ],
      "traktor": [ "МТЗ-Беларус", "Кировец", "John Deere", "New Holland", "ДТ-75" ],
      "moto": [ "Урал", "ИЖ", "Honda", "Yamaha" ]
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
